import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 文件上传
 * @author 严俊华
 */
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import { useEffect, useState } from 'react';
//项目组件
import ReviewModal from '../ReviewModal';
//工具
//css
import styles from './index.module.less';
//常量
const { Dragger } = Upload;
const AntUploadDragger = Dragger;
const FileUpload = ({ canSlice = false, className = '', listType = 'text', multiple = true, action = `/api/minio/v1/file`, accept = '', param = {}, length = 0, size = 0, isCustom = false, hint = '.rar .zip .doc .docx .pdf .jpg...', isDetail = false, defaultFileList = [], onChange = () => { }, onPreview = () => { }, limitFuc = () => true, beforeSliceFunc = () => true, onCustomRequest = () => { }, }) => {
    //文件
    const [fileList, setFileList] = useState([]);
    const [beforeFileList, setBeforeFileList] = useState([]);
    const [reviewModalVisible, setReviewModalVisible] = useState(false);
    const [imgSrc, setImgSrc] = useState('');
    const [previewVideo, setPreviewVideo] = useState('');
    const toggerImageModal = () => {
        setReviewModalVisible(!reviewModalVisible);
    };
    /**
     *上传文件变化
     */
    const uploadChange = (info) => {
        // 文件上传
        const newFileList = [...info.fileList]
            .filter((item) => item.status !== undefined)
            .map((file) => {
            if (file.response && file.response.code == 200) {
                file.url = file.response.data?.fileSrcUrl;
                file.fileObj = file.response.data;
            }
            return file;
        });
        setFileList(newFileList);
        if (info.file.status === 'removed') {
            const newBeforeFileList = [...beforeFileList];
            newBeforeFileList.pop();
            setBeforeFileList(newBeforeFileList);
        }
        onChange(newFileList);
    };
    /**
     * 是否存在指定类型
     * @param ary
     * @param name
     * @returns
     */
    const ishas = (ary, name) => {
        return ary.some((item) => name.includes(item));
    };
    const asyncGetBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    /**
     * 预览
     */
    const handlePreview = async (file) => {
        const imgs = ['.gif', '.jpeg', '.png', '.jpg', '.svg', '.bmp'];
        const videos = [
            '.mp4',
            '.rmvb',
            '.rm',
            '.avi',
            '.ts',
            '.wmv',
            '.mov',
            '.mpeg',
            '.mpg',
            '.3gp',
            '.flv',
            '.da',
        ];
        const name = file.name;
        if (ishas(imgs, name)) {
            // 是图片
            if (!file.url && !file.preview) {
                file.preview = await asyncGetBase64(file.originFileObj);
            }
            setImgSrc(file.url || file.preview);
            setReviewModalVisible(true);
        }
        else if (ishas(videos, name)) {
            // 是视频
            setPreviewVideo(file.url);
            setReviewModalVisible(true);
        }
        onPreview(file);
    };
    /**
     * 上传前触发
     */
    const multipleBeforeUpload = (file) => {
        const newBeforeFileList = [...beforeFileList, file.name];
        setBeforeFileList(newBeforeFileList);
        let check = limitFuc(file);
        // 过滤文件格式
        if (check && accept) {
            check = false;
            const fileHz = file.name.split('.'); // 取后缀
            const acceptTypeArr = accept.split(',');
            acceptTypeArr.some((itemType) => {
                if (check) {
                    return check;
                }
                if (itemType.includes(fileHz.slice(-1)[0])) {
                    check = true;
                    return true;
                }
                else if (itemType.includes('/*')) {
                    const belongType = itemType.split('*')[0];
                    if (file.type.includes(belongType)) {
                        check = true;
                        return true;
                    }
                }
            });
            if (!check) {
                message.error(`请上传正确格式的文件（${accept}）`);
            }
        }
        if (check && length != 0 && beforeFileList.length > length) {
            const files = '文件';
            message.error(`最多上传${length}个${files}!`);
            check = false;
        }
        //  file.size / 1024 / 1024 MB
        if (check && size != 0) {
            const isLt2M = file.size / 1024 / 1024 >= size;
            if (isLt2M) {
                message.error('文件大小不超过' + size + 'MB!');
                check = false;
            }
        }
        if (!check) {
            newBeforeFileList.pop();
            setBeforeFileList(newBeforeFileList);
        }
        return check;
    };
    // 自定义上传
    const customRequest = (option) => {
        onCustomRequest(option);
        // 用来控制，让进度条100%，伪装上传操作
        setTimeout(() => {
            option.onSuccess({}, option.file);
        }, 0);
    };
    /**
     * 外部调用
     * @param list
     */
    const init = (list) => {
        const newFileList = list.map((item) => ({
            fileObj: item,
            name: item.fileName,
            size: item.fileSize,
            thumbUrl: item?.fileSrcUrl,
            url: item?.fileSrcUrl,
            type: item.fileType,
            uid: item.id,
            status: 'done',
        }));
        setBeforeFileList(newFileList);
        setFileList(newFileList);
    };
    useEffect(() => {
        init(defaultFileList);
    }, [defaultFileList]);
    return (_jsxs("div", { className: `${className} ${!isDetail && !(fileList.length >= length)
            ? styles.uploadSelectVisible
            : styles.uploadSelectNotVisible}`, children: [listType === 'text' ? (_jsxs(AntUploadDragger, { name: "file", multiple: multiple, action: action, accept: accept, data: param, headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
                    ct: '1',
                    fp: localStorage.getItem('fp'),
                }, fileList: fileList, listType: listType, onChange: uploadChange, onPreview: handlePreview, beforeUpload: multipleBeforeUpload, customRequest: isCustom ? customRequest : undefined, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: "\u70B9\u51FB\u6216\u5C06\u6587\u4EF6\u62D6\u62FD\u5230\u8FD9\u91CC\u4E0A\u4F20" }), hint ? _jsxs("p", { className: "ant-upload-hint", children: ["\u652F\u6301\u6269\u5C55\u540D\uFF1A", hint] }) : null] })) : null, listType === 'picture-card' ? (canSlice ? (_jsx(ImgCrop, { beforeCrop: beforeSliceFunc, modalTitle: "\u7F16\u8F91\u56FE\u7247", modalOk: '确认', modalCancel: '取消', children: _jsx(Upload, { className: isDetail ? styles['picture-card-detail'] : '', multiple: multiple, action: action, accept: accept, data: param, headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
                        ct: '1',
                        fp: localStorage.getItem('fp'),
                    }, fileList: fileList, listType: listType, onChange: uploadChange, onPreview: handlePreview, beforeUpload: multipleBeforeUpload, customRequest: isCustom ? customRequest : undefined, children: _jsxs("div", { children: [_jsx(PlusOutlined, {}), _jsx("div", { className: "ant-upload-text", children: "\u4E0A\u4F20" })] }) }) })) : (_jsx(Upload, { className: isDetail ? styles['picture-card-detail'] : '', multiple: multiple, action: action, accept: accept, data: param, headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
                    ct: '1',
                    fp: localStorage.getItem('fp'),
                }, fileList: fileList, listType: listType, onChange: uploadChange, onPreview: handlePreview, beforeUpload: multipleBeforeUpload, customRequest: isCustom ? customRequest : undefined, children: _jsxs("div", { children: [_jsx(PlusOutlined, {}), _jsx("div", { className: "ant-upload-text", children: "\u4E0A\u4F20" })] }) }))) : null, _jsx(ReviewModal, { visible: reviewModalVisible, previewImage: imgSrc, previewVideo: previewVideo, onCancel: toggerImageModal })] }));
};
export default FileUpload;
